import { Track, Filler } from './progress-bar.style'

interface IProgressBarProps {
  percentage?: number
  color: string
}

const ProgressBar = ({ percentage = 0, color = '#34a853' }) => {
  return (
    <Track>
      <Filler percentage={percentage} color={color} />
    </Track>
  )
}

export default ProgressBar
